import BaseService from './_base.service';

const URL = "/appuser/user";

export const myuserService = {
    one,
    edit,
    create
};


function one(id,callback) {
    return BaseService.get(URL + "/myinfo/", callback);
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post(URL+"/editmyinfo", body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post(URL+"/changepass", body, callback, true)
}

